<template>
  <DataTableCell full-width>
    <v-select
      v-if="editMode"
      v-model="inputVal"
      :items="items"
      item-title="display_name"
      item-value="value"
      item-props
      :item-disabled="itemDisabled"
      hide-details
      variant="plain"
      persistent-hint
      solo
      full-width
      density="compact"
      :style="{ width: '150px' }"
    />
    <template v-else>
      <span :style="{ fontSize }">{{ shownText }}</span>
    </template>
  </DataTableCell>
</template>

<script>
import DataTableCell from '@/components/userManagement/DataTableCell.vue'

export default {
  name: 'WaterLineRuleDropDown',
  components: { DataTableCell },
  props: {
    editMode: { type: Boolean, default: true },
    value: { required: false },
    items: { type: Array, required: true },
    itemDisabled: { required: false }
  },
  computed: {
    shownText() {
      const item = this.items.find((item) => item.value === this.value)
      return item ? item.display_name : this.value
    },
    inputVal: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('action', val)
      }
    }
  }
}
</script>

<style scoped>
:deep(.v-input__slot) {
  padding: 0 !important;
}

:deep(.v-select__selections) input {
  padding: 0 !important;
  margin: 0 !important;
}

:deep(.v-select__selection) {
  font-size: 14px;
  margin: 0 !important;
}
</style>
